export const getTextWithoutUnderScore = (signature) =>
  signature
    ?.toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
    export const getTextWithoutDashAndUnderscore = (signature) =>
      signature
        ?.toLowerCase()
        .replace(/-|_+/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());

export const getTextWithDash = (signature) =>
  signature
    ?.toLowerCase()
    .replace(/_/g, '-')
    .replace(/\b\w/g, (c) => c.toUpperCase());
